import { isActionOf } from 'typesafe-actions'
import { from, of } from 'rxjs'
import { catchError, exhaustMap, filter, map, switchMap } from 'rxjs/operators'
import { toast } from 'react-toastify'
import { AxiosError } from 'axios'
import { RootEpic } from '../types'
import {
  getBusinessEntitiesRequest,
  getBusinessEntitiesSuccess,
  getBusinessEntitiesFailure,
  createBusinessEntitiesRequest,
  createBusinessEntitiesSuccess,
  createBusinessEntitiesFailure,
  getBusinessEntityDetailsRequest,
  getBusinessEntityDetailsSuccess,
  getBusinessEntityDetailsFailure,
  getUsersForAssignEntityRequest,
  getUsersForAssignEntitySuccess,
  getUsersForAssignEntityFailure,
  updateBusinessEntityDetailsRequest,
  updateBusinessEntityDetailsSuccess,
  updateBusinessEntityDetailsFailure,
  updateBusinessEntityUsersRequest,
  updateBusinessEntityUsersSuccess,
  updateBusinessEntityUsersFailure,
  updateBusinessEntitySettingsRequest,
  updateBusinessEntitySettingsSuccess,
  updateBusinessEntitySettingsFailure,
  deleteBusinessEntityUsersRequest,
  deleteBusinessEntityUsersSuccess,
  deleteBusinessEntityUsersFailure,
  getBusinessEntitiesForAssignToUserRequest,
  getBusinessEntitiesForAssignToUserSuccess,
  getBusinessEntitiesForAssignToUserFailure,
} from '../actions'

export const fetchBusinessEntitiesEpic: RootEpic = (action$, state$, { fetchBusinessEntities }) =>
  action$.pipe(
    filter(isActionOf([getBusinessEntitiesRequest])),
    switchMap(({ payload: { ...params } }) =>
      from(
        fetchBusinessEntities({
          token: state$.value.app.authToken as string,
          limit: 10,
          ...state$.value.auditLogs.logs.filters,
          ...params,
        }),
      ).pipe(
        map((response) => getBusinessEntitiesSuccess(response)),
        catchError((message) => {
          toast.error('Failed to fetch entities.')
          return of(getBusinessEntitiesFailure(message))
        }),
      ),
    ),
  )

export const getBusinessEntityDetailsEpic: RootEpic = (action$, state$, { getBusinessEntityDetails }) =>
  action$.pipe(
    filter(isActionOf([getBusinessEntityDetailsRequest])),
    switchMap(({ payload }) =>
      from(
        getBusinessEntityDetails({
          token: state$.value.app.authToken as string,
          ...payload,
        }),
      ).pipe(
        map((response) => getBusinessEntityDetailsSuccess(response)),
        catchError((message) => {
          toast.error('Failed to fetch business entity detail.')
          return of(getBusinessEntityDetailsFailure(message))
        }),
      ),
    ),
  )

export const createBusinessEntityEpic: RootEpic = (action$, state$, { createBusinessEntity }) =>
  action$.pipe(
    filter(isActionOf([createBusinessEntitiesRequest])),
    exhaustMap(({ payload }) =>
      from(
        createBusinessEntity({
          token: state$.value.app.authToken as string,
          ...payload,
        }),
      ).pipe(
        map((response) => {
          toast.success(response.message)
          return createBusinessEntitiesSuccess(response)
        }),
        catchError((error: AxiosError) => {
          toast.error(error.response?.data.message || 'Failed to create Business Entity.')
          return of(createBusinessEntitiesFailure(error))
        }),
      ),
    ),
  )

export const updateBusinessEntityDetailsEpic: RootEpic = (action$, state$, { updateBusinessEntityDetails }) =>
  action$.pipe(
    filter(isActionOf([updateBusinessEntityDetailsRequest])),
    exhaustMap(({ payload }) =>
      from(
        updateBusinessEntityDetails({
          token: state$.value.app.authToken as string,
          ...payload,
        }),
      ).pipe(
        map((response) => {
          toast.success('Business Entity successfully updated.')
          return updateBusinessEntityDetailsSuccess(response)
        }),
        catchError((error: AxiosError) => {
          toast.error(error.response?.data.message || 'Failed to update Business Entity.')
          return of(updateBusinessEntityDetailsFailure(error))
        }),
      ),
    ),
  )

export const updateBusinessEntityUsersEpic: RootEpic = (action$, state$, { updateBusinessEntityUsers }) =>
  action$.pipe(
    filter(isActionOf([updateBusinessEntityUsersRequest])),
    exhaustMap(({ payload }) =>
      from(
        updateBusinessEntityUsers({
          token: state$.value.app.authToken as string,
          ...payload,
        }),
      ).pipe(
        map((response) => {
          toast.success('Business Entity successfully updated.')
          return updateBusinessEntityUsersSuccess(response)
        }),
        catchError((error: AxiosError) => {
          toast.error(error.response?.data.message || 'Failed to update Business Entity.')
          return of(updateBusinessEntityUsersFailure(error))
        }),
      ),
    ),
  )
export const updateBusinessEntitySettingsEpic: RootEpic = (action$, state$, { updateBusinessEntitySettings }) =>
  action$.pipe(
    filter(isActionOf([updateBusinessEntitySettingsRequest])),
    exhaustMap(({ payload }) =>
      from(
        updateBusinessEntitySettings({
          token: state$.value.app.authToken as string,
          ...payload,
        }),
      ).pipe(
        map((response) => {
          toast.success('Business Entity successfully updated.')
          return updateBusinessEntitySettingsSuccess(response)
        }),
        catchError((error: AxiosError) => {
          toast.error(error.response?.data.message || 'Failed to update Business Entity.')
          return of(updateBusinessEntitySettingsFailure(error))
        }),
      ),
    ),
  )

export const deleteBusinessEntityUsersEpic: RootEpic = (action$, state$, { deleteBusinessEntityUsers }) =>
  action$.pipe(
    filter(isActionOf([deleteBusinessEntityUsersRequest])),
    exhaustMap(({ payload }) =>
      from(
        deleteBusinessEntityUsers({
          token: state$.value.app.authToken as string,
          ...payload,
        }),
      ).pipe(
        map((response) => {
          toast.success('Business Entity successfully updated.')
          return deleteBusinessEntityUsersSuccess(response)
        }),
        catchError((error: AxiosError) => {
          toast.error(error.response?.data.message || 'Failed to update Business Entity.')
          return of(deleteBusinessEntityUsersFailure(error))
        }),
      ),
    ),
  )

export const getUsersForAssignEntityEpic: RootEpic = (action$, state$, { fetchUsersForAssignEntity }) =>
  action$.pipe(
    filter(isActionOf([getUsersForAssignEntityRequest])),
    switchMap(({ payload }) =>
      from(
        fetchUsersForAssignEntity({
          token: state$.value.app.authToken as string,
          limit: 10,
          ...payload,
        }),
      ).pipe(
        map((response) => getUsersForAssignEntitySuccess(response)),
        catchError((message) => {
          toast.error('Failed to fetch business entity detail.')
          return of(getUsersForAssignEntityFailure(message))
        }),
      ),
    ),
  )

export const getBusinessEntitiesForAssignToUserEpic: RootEpic = (
  action$,
  state$,
  { fetchBusinessEntitiesForAssignToUser },
) =>
  action$.pipe(
    filter(isActionOf([getBusinessEntitiesForAssignToUserRequest])),
    switchMap(({ payload }) =>
      from(
        fetchBusinessEntitiesForAssignToUser({
          token: state$.value.app.authToken as string,
          limit: 10,
          ...payload,
        }),
      ).pipe(
        map((response) => getBusinessEntitiesForAssignToUserSuccess(response)),
        catchError((message) => {
          toast.error('Failed to fetch business entities.')
          return of(getBusinessEntitiesForAssignToUserFailure(message))
        }),
      ),
    ),
  )

export default [
  fetchBusinessEntitiesEpic,
  getBusinessEntityDetailsEpic,
  getUsersForAssignEntityEpic,
  createBusinessEntityEpic,
  updateBusinessEntityDetailsEpic,
  updateBusinessEntityUsersEpic,
  deleteBusinessEntityUsersEpic,
  updateBusinessEntitySettingsEpic,
  getBusinessEntitiesForAssignToUserEpic,
]
